
<template>
  <div>
    <naj-box
      v-if="isNewMode"
      :title="local.waiverRequest.caseInfo"
    >
      <v-row>
        <v-col cols="6">
          <naj-input
            :type-id="formFieldType.multipleSelectBox"
            :label="local.waiverRequest.prosecutor"
            :value.sync="formModel.prosecutors"
            :items="prosecutors"
            item-text="name"
            item-value="id"
            validates="required"
            :disabled="formModel.prosecutors && formModel.prosecutors.length > 0 && !isNewMode"
            @change="setApplicantCaseParty"
          ></naj-input>
        </v-col>
        <v-col cols="6">
          <naj-input
            :type-id="formFieldType.multipleSelectBox"
            :label="local.waiverRequest.defendant"
            :value.sync="formModel.defendants"
            :items="defendants"
            item-text="name"
            item-value="id"
            validates="required"
            :disabled="formModel.defendants && formModel.defendants.length > 0 && !isNewMode"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>
    <naj-box
      v-if="!isNewMode"
      :title="local.waiverRequest.caseInfo"
      class="readonly-case-info"
    >
      <v-row>
        <v-col
          cols="6"
          class="text-h6 font-weight-bold"
        >
          {{ local.waiverRequest.prosecutor }}
          <ul>
            <li
              v-for="(prosecutor, index) in selectedProsecutor"
              :key="index"
            >
              {{ index + 1 }} - {{ prosecutor }}
            </li>
          </ul>
        </v-col>
        <v-col
          cols="6"
          class="text-h6 font-weight-bold"
        >
          {{ local.waiverRequest.defendant }}
          <ul>
            <li
              v-for="(defendant, index) in selectedDefendant"
              :key="index"
            >
              {{ index + 1 }} - {{ defendant }}
            </li>
          </ul>
        </v-col>
      </v-row>
    </naj-box>

    <naj-box :title="local.waiverRequest.caseType">
      <v-row>
        <v-col
          cols="6"
          class="text-right"
        >
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.waiverRequest.waiverType"
            :value.sync="formModel.waiverTypeId"
            :items="waiverTypes"
            item-text="name"
            item-value="id"
            validates="required"
            :disabled="!isNewMode"
          ></naj-input>
        </v-col>
      </v-row>
      <v-row v-if="formModel.waiverTypeId == waiverTypeEnum.waiverWithConditions">
        <v-col cols="12">
          <naj-input
            :type-id="formFieldType.textarea"
            :value.sync="formModel.notes"
            :label="local.waiverRequest.notes"
            validates="required|arabic|max:200"
            :disabled="!isNewMode"
          ></naj-input>
        </v-col>
      </v-row>
      <v-row
        v-if="formModel.waiverTypeId == waiverTypeEnum.waiverWithConditions"
        class="mt-2"
      >
        <v-col
          cols="12"
        >
          <naj-input
            :type-id="formFieldType.checkbox"
            :value.sync="formModel.conditionValide"
            :label="local.waiverRequest.conditionValide"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
import { waiverTypeEnum } from '@/helpers/enum';

export default {
  name: 'WaiverRequest',
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      waiverTypes: [
        {
          id: 1,
          name: 'تنازل بدون مقابل',
        },
        {
          id: 2,
          name: 'تنازل بمقابل',
        },
      ],
      waiverTypeEnum,
      prosecutors: [],
      defendants: [],
      selectedProsecutor: [],
      selectedDefendant: [],
    };
  },
  computed: {
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    ...mapCasesActions(['getCaseBasicParties', 'getJudgementCodeByObjectKey', 'getUserCasePartyRoleInCase']),
    init() {
      this.loading = true;
      const params = {
        isPega: 'true',
        objectKey: this.formModel.case.objectKey,
      };

      const promises = [
        this.getCaseBasicParties(params),
        this.getUserInfo(),
      ];

      if (!this.formModel.judgementCode) {
        promises.push(this.getJudgementCodeByObjectKey({ caseObjectKey: this.$route.query.objectKey }));
      }

      Promise.all(promises)
        .then(([casePartiesResponse, userInfoResponse, judgmentsResponse]) => {
          const caseParties = casePartiesResponse.data;
          this.prosecutors = caseParties
            .filter(p => p.casePartyRole === 1)
            .map(p => ({
              id: p.casePartyId,
              name: `${p.name} - ${p.identityNumber}`,
            }));

          this.defendants = caseParties
            .filter(p => p.casePartyRole !== 1)
            .map(p => ({
              id: p.casePartyId,
              name: `${p.name} - ${p.identityNumber}`,
            }));

          this.formModel.judgementCode = this.formModel.judgementCode == undefined ? judgmentsResponse.data : this.formModel.judgementCode;
          this.formModel.socialIdType = userInfoResponse.socialIdType;
          this.formModel.socialId = userInfoResponse.socialId;
          this.formModel.firstName = userInfoResponse.firstName;
          this.formModel.fatherName = userInfoResponse.fatherName;
          this.formModel.grandFatherName = userInfoResponse.grandFatherName;
          this.formModel.familyName = userInfoResponse.familyName;
          this.formModel.dateOfBirth = userInfoResponse.dateOfBirth;
          this.formModel.nationalityCountryId = userInfoResponse.nationalityCountryId;
          this.formModel.sex = userInfoResponse.gender;
          this.formModel.fullName = userInfoResponse.fullName;
          this.formModel.conditionValide = false;

          if (!this.isNewMode) {
            this.selectedProsecutor = caseParties.filter(p => this.formModel.prosecutors.includes(p.casePartyId)).map(p => `${p.name} - ${p.identityNumber}`);
            this.selectedDefendant = caseParties.filter(p => this.formModel.defendants.includes(p.casePartyId)).map(p => `${p.name} - ${p.identityNumber}`);
          }
        })
        .catch((error) => {
          console.error('Error while fetching data:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setApplicantCaseParty() {
      if (this.formModel.prosecutors && this.formModel.prosecutors.length > 0) {
        this.formModel.applicantCasePartyId = this.formModel.prosecutors[0];
      } else {
        this.formModel.applicantCasePartyId = null;
      }
    },
  },
};
</script>

<style scoped>
.waiver-page-container {
  direction: rtl;
  padding: 32px 0 0 0;
}
.page-title {
  font-size: 2.2rem;
  font-weight: bold;
  color: #153c3c;
  text-align: center;
  margin-bottom: 32px;
}
.case-info-card {
  max-width: 90%;
  margin: 0 auto;
  border-radius: 16px;
  background: #f7f6f2;
  box-shadow: none;
}
.case-info-header {
  background: #f0ece6;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  font-size: 1.2rem;
  font-weight: 600;
  color: #3d4b4b;
}
.field-label {
  font-size: 1rem;
  font-weight: 500;
  color: #3d4b4b;
  margin-bottom: 4px;
  display: block;
}
.field-input {
  background: #ececec;
}
.case-info-card {
  margin-bottom: 20px;
}
.text-left {
  padding-left: 7%;
  padding-bottom: 7%;
}
.readonly-case-info {
  font-family: 'saudi-riyal-custom', Almarai, sans-serif !important;
}
.readonly-case-info ul,
.readonly-case-info li {
  font-family: inherit !important;
}
::v-deep  .multi-selection {
  overflow: visible !important;
  font-size: 25px;
}
</style>
